<template>
  <UCard
    class="todo-card"
    :ui="{
      root: 'todo-card__root',
      body: 'todo-card__body',
      footer: 'todo-card__footer',
    }"
  >
    <!-- Заголовок с ссылкой на детальную страницу -->
    <template #header>
      <NuxtLink
        :to="`/notes/${id}`"
        class="text-primary hover:text-primary-800 underline transition-all text-lg font-bold"
        :class="{ 'text-slate-500': !title }"
        >{{ title || "Без названия" }}</NuxtLink
      >
    </template>

    <!-- Список задач (показываем только первые несколько) -->
    <ul class="todo-card__list">
      <li
        v-for="item in itemsToShow"
        :key="item.id"
        class="todo-card__list-item flex items-center gap-2 mb-1"
      >
        <UCheckbox
          v-model="item.complete"
          disabled
          :label="item.text || 'Без текста'"
        />
      </li>
      <!-- Индикатор, что есть еще задачи -->
      <li v-if="Array.isArray(items) && items.length > itemsMaxCount">...</li>
    </ul>

    <!-- Кнопки действий -->
    <template #footer>
      <UButton
        variant="ghost"
        icon="i-lucide-trash"
        color="warning"
        @click="$emit('delete', id)"
      ></UButton>
      <UButton
        variant="ghost"
        icon="i-lucide-edit"
        color="primary"
        @click="$emit('edit', id)"
      ></UButton>
    </template>
  </UCard>
</template>

<script setup lang="ts">
import type { ToDoList } from "../types/common";

// Определяем события компонента
defineEmits(["delete", "edit"]);

// Получаем props из ToDoList интерфейса
const props = defineProps<ToDoList>();

// Максимальное количество задач для отображения в карточке
const itemsMaxCount = 3;

/**
 * Вычисляемые задачи для отображения (ограниченное количество)
 */
const itemsToShow = computed(() => {
  return props.items?.slice(0, itemsMaxCount) || [];
});
</script>

<style lang="scss">
.todo-card {
  &__root {
    display: flex;
    flex-direction: column;
  }
  &__body {
    flex-grow: 1;
  }
  &__footer {
    margin-top: auto;
  }
}
</style>
